import { Component, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Supplier } from 'app/entities';
import { emailAddress } from 'app/helpers/validators';
import { SuppliersService } from 'app/main/pages/products/supplier.service';
import { AlertService } from 'app/services/alert.service';
import { CnpjAutocompleteService } from 'app/services/cnpj-autocomplete.service';
import { Subject, Subscription } from 'rxjs';

@Component({
    selector: 'app-form-supplier-create-or-edit',
    templateUrl: './form-supplier-create-or-edit.component.html',
    styleUrls: ['./form-supplier-create-or-edit.component.scss']
})
export class FormSupplierCreateOrEditComponent implements OnInit, OnDestroy {

    /** Dentro do diálogo de cadastro: as ações ficam no rodapé do diálogo */
    @Input() inDialog = false;
    @Input('supplier') supplier: Supplier = new Supplier();
    @ViewChild('cnpjInput') cnpjInput?: any;
    @Output() onCreatedSupplier = new Subject<Supplier>();
    @Output() onUpdatedSupplier = new Subject<Supplier>();

    loading = false;
    form?: FormGroup;
    private cnpjAutocompleteSubscription?: Subscription;

    constructor(
        private _formBuilder: FormBuilder,
        private _alertService: AlertService,
        private _suppliersService: SuppliersService,
        private _cnpjAutocompleteService: CnpjAutocompleteService
    ) {}

    ngOnInit(): void {
        this.createForm();
    }

    ngOnDestroy(): void {
        this.cnpjAutocompleteSubscription?.unsubscribe();
    }

    createForm() {
        if (!this.supplier) {
            this.supplier = new Supplier();
            this.supplier.status = 1;
        }

        this.form = this._formBuilder.group({
            id: [this.supplier?.id],
            cnpj: [this.supplier?.cnpj],
            razao_social: [this.supplier?.razaoSocial, [Validators.required]],
            phone: [this.supplier?.phone],
            email: [this.supplier?.email, [emailAddress()]],
            responsible: [this.supplier?.responsible],
            address: [this.supplier?.address],
            address_number: [this.supplier?.addressNumber],
            address_neighborhood: [this.supplier?.addressNeighborhood],
            address_complement: [this.supplier?.addressComplement],
            address_city: [this.supplier?.addressCity],
            address_state: [this.supplier?.addressState],
            cep: [this.supplier?.cep],
            status: [this.supplier?.status ?? 1],
        });

        if (!this.supplier?.id) {
            setTimeout(() => this.cnpjInput?.nativeElement?.focus(), 100);
        }

        this.cnpjAutocompleteSubscription?.unsubscribe();
        this.cnpjAutocompleteSubscription = this._cnpjAutocompleteService.watchForm(this.form, 'cnpj', {
            razao_social: 'razao_social',
            phone: data => data.ddd_telefone_1 || data.ddd_telefone_2 || data.ddd_fax,
            email: 'email',
            cep: 'cep',
            address: 'logradouro',
            address_number: 'numero',
            address_city: 'municipio',
            address_state: 'uf',
            address_neighborhood: 'bairro',
            address_complement: 'complemento',
        });
    }

    store() {
        if (this.form?.valid) {
            this.loading = true;
            this._suppliersService.store(this.form?.value).subscribe((res) => {
                this._alertService.success('Fornecedor criado com sucesso');
                this.onCreatedSupplier.next(res);
                this.loading = false;
                this.form?.reset();
            }, (error) => {
                this._alertService.error(error);
                this.loading = false;
            });
        }
    }

    update() {
        if (this.form?.valid && this.supplier?.id) {
            this.loading = true;
            this._suppliersService.update(this.supplier.id, this.form?.value).subscribe((res) => {
                this._alertService.success('Fornecedor atualizado com sucesso');
                this.onUpdatedSupplier.next(res);
                this.loading = false;
            }, (error) => {
                this._alertService.error(error);
                this.loading = false;
            });
        }
    }

    toggleStatus(active: boolean) {
        if (!this.supplier) return;
        this.supplier.status = active ? 1 : 2;
        this.form?.controls['status'].setValue(this.supplier.status);
        this.form?.markAsDirty();
    }
}
